/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Benefit_Support_DescriptionInputs */

const en_business_benefit_support_description = /** @type {(inputs: Business_Benefit_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct line support via Slack or Email`)
};

const es_business_benefit_support_description = /** @type {(inputs: Business_Benefit_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soporte directo por Slack o correo electrónico`)
};

/**
* | output |
* | --- |
* | "Direct line support via Slack or Email" |
*
* @param {Business_Benefit_Support_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_benefit_support_description = /** @type {((inputs?: Business_Benefit_Support_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Benefit_Support_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_benefit_support_description(inputs)
	return en_business_benefit_support_description(inputs)
});